import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';
import InvoiceTableRow from './InvoiceTableRow';
import InvoiceTableFooter from './InvoiceTableFooter';
import InvoiceNotes from './InvoiceNotes';

const styles = StyleSheet.create({
  tableContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap'
  }
});

const InvoiceItemsTable = ({ invoice, retailerInfo }) => (
  <View style={styles.tableContainer}>
    <InvoiceTableRow invoice={invoice} items={invoice.products} retailerInfo={retailerInfo} />
    <InvoiceTableFooter invoice={invoice} retailerInfo={retailerInfo} />
    <InvoiceNotes invoice={invoice} />
  </View>
);

export default InvoiceItemsTable;